import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgFor, NgIf } from '@angular/common';

import { EorderWizardService } from '../../../services/eorder-wizard.service';
import { EorderWizardStepperService } from '../../../services/eorder-wizard-stepper.service';
import { EorderWizardStep } from '../../../models/eorder-wizard-state';

enum StepStatus {
	WIP = 0,
	WAIT = 1,
	DONE = 2
}

interface EorderWizardStepObject {
	num: number;
	labelTransId: string;
	status: StepStatus;
}

@Component({
	selector: 'copo-eorder-wizard-stepper',
	templateUrl: './wizard-stepper.component.html',
	styleUrl: './wizard-stepper.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgFor, NgIf, MatRippleModule, TranslateModule, MatIconModule, MatButtonModule]
})
export class WizardStepperComponent implements OnDestroy {
	@Input() currentStep = 0;

	readonly WIP = StepStatus.WIP;
	readonly WAIT = StepStatus.WAIT;
	readonly DONE = StepStatus.DONE;

	steps: EorderWizardStepObject[] = [
		{
			num: 0,
			labelTransId: 'eorder.wizard.stepper.step.order.information',
			status: StepStatus.WIP
		},
		{
			num: 1,
			labelTransId: 'eorder.wizard.stepper.step.product.modification',
			status: StepStatus.WAIT
		},
		{
			num: 2,
			labelTransId: 'eorder.wizard.stepper.step.summary',
			status: StepStatus.WAIT
		}
	];

	private readonly stepChangeSupscription: Subscription;

	constructor(
		private readonly eorderStepperService: EorderWizardStepperService,
		private readonly eorderWizardService: EorderWizardService
	) {
		this.stepChangeSupscription = this.eorderStepperService.onStepChanged.subscribe({
			next: (result: { step: number }) => {
				this.currentStep = result.step;
				this.rearengeSteps();
			}
		});
	}

	ngOnDestroy() {
		this.stepChangeSupscription.unsubscribe();
	}

	nextStep() {
		this.currentStep += 1;
		this.rearengeSteps();
	}

	isSummaryStep() {
		return this.eorderWizardService.getState().stepIndex === EorderWizardStep.SUMMARY;
	}

	print() {
		print();
	}

	async onStepClick(stepClick: number) {
		await this.eorderWizardService.actionMoveUsingSteps(stepClick);
	}

	private rearengeSteps() {
		this.processCurrentStep();
		this.processPriviousStep();
		this.processLeftSteps();
	}

	private processCurrentStep() {
		this.steps[this.currentStep].status = StepStatus.WIP;
	}

	private processPriviousStep() {
		if (this.currentStep <= 0) {
			return;
		}
		for (let i = 0; i < this.currentStep; i++) {
			this.steps[i].status = StepStatus.DONE;
		}
	}

	private processLeftSteps() {
		if (this.currentStep === this.steps.length - 1) {
			return;
		}
		for (let i = this.currentStep + 1; i < this.steps.length; i++) {
			this.steps[i].status = StepStatus.WAIT;
		}
	}
}
